<div *ngIf="financialStatementList && financialStatementList.length > 0">
  <h2 class='h5'>{{code}} Hissesinin Finansal Tablosu</h2>
  <div class='table-responsive'>
    <table class='table table-sm table-bordered tables'>
      <caption>{{code}} Hissesinin Finansal Tablosu</caption>
      <thead>
        <tr>
          <th scope="col" id="headerYear"></th>
          <th *ngFor="let statement of financialStatementList; let i = index" id="headerDate{{i}}">{{ statement.date | date:
            'dd.MM.yyyy' }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row" id="currentAssets">Dönen Varlıklar</th>
          <td *ngFor="let statement of financialStatementList; let i = index" id="currentAssets{{i}}">{{
            statement.currentAssets | currency:'TRY' }}</td>
        </tr>
        <tr>
          <th scope="row" id="fixedAssets">Duran Varlıklar</th>
          <td *ngFor="let statement of financialStatementList; let i = index" id="fixedAssets{{i}}">{{ statement.fixedAssets
            | currency:'TRY' }}</td>
        </tr>
        <tr>
          <th scope="row" id="shortTermLiabilities">Kısa Vadeli Yük.</th>
          <td *ngFor="let statement of financialStatementList; let i = index" id="shortTermLiabilities{{i}}">{{
            statement.shortTermLiabilities | currency:'TRY' }}</td>
        </tr>
        <tr>
          <th scope="row" id="longTermLiabilities">Uzun Vadeli Yük.</th>
          <td *ngFor="let statement of financialStatementList; let i = index" id="longTermLiabilities{{i}}">{{
            statement.longTermLiabilities | currency:'TRY' }}</td>
        </tr>
        <tr>
          <th scope="row" id="equities">Özkaynaklar</th>
          <td *ngFor="let statement of financialStatementList; let i = index" id="equities{{i}}">{{ statement.equities |
            currency:'TRY' }}</td>
        </tr>
        <tr>
          <th scope="row" id="netProfitLoss">Net Dönem Karı</th>
          <td *ngFor="let statement of financialStatementList; let i = index" id="netProfitLoss{{i}}">{{
            statement.netProfitLoss | currency:'TRY' }}</td>
        </tr>
        <tr>
          <th scope="row" id="cashRatio">Nakit Oranı</th>
          <td *ngFor="let statement of financialStatementList; let i = index" id="cashRatio{{i}}">{{ statement.cashRatio |
            number:'1.0-2' }}</td>
        </tr>
        <tr>
          <th scope="row" id="acidTestRatio">Asit Test Oranı</th>
          <td *ngFor="let statement of financialStatementList; let i = index" id="acidTestRatio{{i}}">{{
            statement.acidTestRatio | number:'1.0-2' }}</td>
        </tr>
        <tr>
          <th scope="row" id="currentRatio">Cari Oran</th>
          <td *ngFor="let statement of financialStatementList; let i = index" id="currentRatio{{i}}">{{ statement.currentRatio
            | number:'1.0-2' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <br>
  <div>
    <p>Not: <a target='_blank' class='href' alt='Bilanço Nedir' title='Bilanço Nedir'
        href='https://www.halkaarz.info/tr/info/bilanco-nedir'>
        <strong>Bilanço</strong>
      </a> esasen bir şirketin varlıklarını, yükümlülüklerini ve öz kaynaklarını belirli bir tarih aralığında raporlayan
      <strong>finansal tablo</strong>yu ifade eder.
    </p>
  </div>
</div>